import React, { useId, useState } from 'react';
interface AccordionRowProps {
  title: string;
  body: string;
}
export function AccordionRow({
  title,
  body
}: AccordionRowProps) {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const buttonId = useId();
  return <div className="border-t border-ink/10" data-id="element-1" data-mp="2d7m7uheq0rug">
      <h4 data-id="element-2" data-mp="28et0dlrvb5eo">
        <button type="button" id={buttonId} aria-expanded={open} aria-controls={panelId} onClick={() => setOpen(prev => !prev)} className="w-full flex items-start justify-between gap-6 py-5 text-left transition-opacity duration-150 ease-out hover:opacity-70 focus:outline-none focus-visible:ring-1 focus-visible:ring-brass" data-id="element-3" data-mp="28e9k09hv8p2r">
          <span className="font-serif font-light text-lg md:text-xl leading-snug text-ink" data-id="element-4" data-mp="2s43faxjshmbq">
            {title}
          </span>
          <span aria-hidden="true" className="font-serif text-brass text-xl leading-none shrink-0 pt-1" data-id="element-5" data-mp="11qw5j9df4k64">
            {open ? '×' : '+'}
          </span>
        </button>
      </h4>

      <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-200 ease-out ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-6" data-mp="3g29c5d9touqt">
        <div className="overflow-hidden" data-id="element-7" data-mp="3uu1pxktyy0qf">
          <p className="font-sans font-light text-base text-ink/70 leading-relaxed max-w-2xl pb-6 md:pr-12" data-id="element-8" data-mp="3uv33bvygizbb">
            {body}
          </p>
        </div>
      </div>
    </div>;
}
interface AccordionGroupProps {
  label?: string;
  note?: string;
  children: React.ReactNode;
  className?: string;
}
export function AccordionGroup({
  label,
  note,
  children,
  className = ''
}: AccordionGroupProps) {
  return <div className={className} data-id="element-9" data-mp="2eeqetozcm121">
      {label && <div className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-ink/50 mb-2" data-id="element-10" data-mp="2eg1qsc2y6f48">
          {label}
        </div>}
      {note && <p className="font-serif italic font-light text-ink/60 text-base mb-6" data-id="element-11" data-mp="2bcvrhl9u0y99">
          {note}
        </p>}
      <div className={`border-b border-ink/10 ${label && !note ? 'mt-6' : ''}`} data-id="element-12" data-mp="27cbtyglcjsml">
        {children}
      </div>
    </div>;
}